export default __webpack_public_path__ + "static/media/ZenaColored.ac3957fd.svg";